import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from '@/shared/ui';
import { useAuthStore } from '@/features/auth';
import { useChangelogState, useMarkImportantSeen } from '../api/queries';
import styles from './WhatsNewModal.module.css';

export const WhatsNewModal: React.FC = () => {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const { data } = useChangelogState(isAuthenticated);
  const markSeen = useMarkImportantSeen();
  const navigate = useNavigate();
  const release = data?.importantRelease ?? null;
  const [dismissedId, setDismissedId] = useState<string | null>(null);
  const open = release !== null && dismissedId !== release.id;

  const close = () => {
    if (!release) return;
    setDismissedId(release.id);
    markSeen.mutate();
  };

  if (!release) return null;

  return (
    <Dialog open={open} onOpenChange={(next) => (next ? undefined : close())}>
      <DialogContent>
        <DialogTitle>{release.title}</DialogTitle>
        {release.version && <DialogDescription className={styles.version}>Версия {release.version}</DialogDescription>}
        {release.headline && <p className={styles.headline}>{release.headline}</p>}
        {release.sections.map((section) => (
          <div key={section.title} className={styles.section}>
            <div className={styles.sectionTitle}>{section.title}</div>
            <div className={styles.list}>
              {section.entries.map((entry) => (
                <div key={entry.id} className={styles.item}>
                  {entry.text}
                </div>
              ))}
            </div>
          </div>
        ))}
        <DialogFooter>
          <Button
            variant="ghost"
            onClick={() => {
              close();
              navigate('/changelog');
            }}
          >
            Все обновления
          </Button>
          <Button onClick={close}>Понятно</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
